import React from 'react';
import { QUALITY_STATUS, IMPROVEMENT_STATUS } from '../constants/dataQuality';

const STYLE_MAP = {
  good: 'bg-green-100 text-green-800 border-green-200',
  watch: 'bg-amber-100 text-amber-900 border-amber-200',
  poor: 'bg-red-100 text-red-800 border-red-200',
  unknown: 'bg-gray-100 text-gray-700 border-gray-200',
  improved: 'bg-green-100 text-green-800 border-green-200',
  unchanged: 'bg-gray-100 text-gray-700 border-gray-200',
  worsened: 'bg-red-100 text-red-800 border-red-200',
  not_comparable: 'bg-gray-100 text-gray-600 border-gray-200'
};

export function getStatusMeta(status, kind = 'quality') {
  const normalized = (status || 'unknown').toLowerCase();
  const catalog = kind === 'improvement' ? IMPROVEMENT_STATUS : QUALITY_STATUS;
  return catalog[normalized] || catalog.unknown || { label: normalized, description: '' };
}

export default function DataQualityStatusBadge({ status, kind = 'quality', showDescription = false }) {
  const normalized = (status || 'unknown').toLowerCase();
  const meta = getStatusMeta(normalized, kind);

  return (
    <div className="inline-flex flex-col gap-1">
      <span
        className={`inline-flex px-2.5 py-1 rounded-full text-xs font-medium border ${STYLE_MAP[normalized] || STYLE_MAP.unknown}`}
        title={meta.description}
      >
        {meta.label}
      </span>
      {showDescription && meta.description ? (
        <span className="text-xs text-gray-500 max-w-xs">{meta.description}</span>
      ) : null}
    </div>
  );
}
